import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  alerts$: BehaviorSubject<Alert[]> = new BehaviorSubject([]);
  nextId = 0;

  constructor() {}

  success(message: AlertMessage) {
    this.addAlert(AlertType.Success, message);
  }

  error(message: AlertMessage) {
    this.addAlert(AlertType.Error, message);
  }

  info(message: AlertMessage) {
    this.addAlert(AlertType.Info, message);
  }

  warning(message: AlertMessage) {
    this.addAlert(AlertType.Warning, message);
  }

  private addAlert(alertType: AlertType, message: AlertMessage) {
    const alert = new Alert(this.nextId, alertType, message);
    this.alerts$.next([... this.alerts$.getValue(), alert]);
    this.nextId += 1;
  }

  removeAlert(alertToRemove: Alert) {
    const currentAlerts = this.alerts$.getValue();
    const updatedAlerts = currentAlerts.filter((alert: Alert) => alert.id !== alertToRemove.id);

    this.alerts$.next(updatedAlerts);
  }

  clearAlerts() {
    this.alerts$.next([]);
  }

}

export class Alert {
  id: number;
  type: AlertType;
  message: AlertMessage;

  constructor(id: number, type: AlertType, message: AlertMessage) {
    this.id = id;
    this.type = type;
    this.message = message;
  }
}

export class AlertMessage {
  title: string;
  content: string;
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}
